import { GENImagePopup } from "../components/imagepopup/state"
import { DATFeedback } from "../features/datdocuments/feedback/state"
import { DATSearchPaket } from "../features/datdocuments/searchpaket/state"
import { QUTOffering } from "../features/qutoffering/offering/state"
import { kpiState } from "../features/kpi/state"

export let features = {
  GENImagePopup,
  DATFeedback,
  DATSearchPaket,
  QUTOffering,
  KPI: kpiState,
}
